<script>
  import RssButton from "./RssButton.svelte";
  import Sort from "./Sort.svelte";

  export let podcast;
  export let cover;
  export let compact;
</script>

<style>
  .imgContainer {
    max-height: 100px;
  }

  .imgContainer:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }

  .imgContent {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .imgContent img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .creator {
    font-weight: normal;
    font-size: 1.25rem;
  }

  .sub-menu{
    background-color: #141415;
    padding-top: 15px;
  }

  @media (min-width: 768px) {
    .imgContainer {
      max-height: unset;
    }
    .imgContent img {
      object-fit: cover;
    }

    .sub-menu{
      background-color: #141415;
      border-bottom: none;
      border-top: none;
      padding-top: 0px;
    }

  }
</style>

<div class="row align-items-center h-100 sub-menu">

  <div class="col-12 col-md-10 d-flex align-items-start">
    <div class="d-flex justify-content-start">
      <h6 class="description">
        {@html podcast.description}
      </h6>
    </div>
  </div>

  <div class="col-12 col-md-2 d-flex flex-column align-items-end justify-content-end pt-4">
    <div class="d-flex justify-content-between">
      <RssButton identifier={podcast.identifier} />
    </div>
  </div>


</div>
